module.exports = __webpack_public_path__ + "img/jmsj.45aec15a.jpg";